import React from "react";

const sizes = {
  textxs: "text-[14px] font-medium",
  text4xl:
    "text-[40px] font-medium lg:text-[34px] md:text-[38px] sm:text-(36px]",
  text6xl:
    "text-[52px] font-medium lg:text-[44px] md:text-[44px] sm:text-[38px]",
  text8xl: "text-[100px] font-medium lg:text-[100px] md:text-[48px]",
  headingxs: "text-[16px] font-semibold lg:text-[13px]",
  headings:
    "text-[28px] font-semibold lg:text-[23px] md:text-[26pxl sm:text-[24px]",
  headingmd:
    "text-[36px] font-semibold lg:text-[30px] md:text-[34px] sm:text-[32px]",
  headinglg:
    "text-[40px] font-semibold lg:text-[34px] md:text-[38px] sm:text-[36px]",
  headingxl: "text-[96px] font-semibold lg:text-[96px] md: text-[48px] ",
};

const Heading = ({
  children,
  className = "",
  size = "textxs",
  as,
  ...restProps
}) => {
  const Component = as || "h6";

  return (
    <Component
      className={`text-gray-400_01 font-spacegrotesk ${className} ${sizes[size]}`}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export { Heading };
